
function countObjectKeys(obj) { 
    return Object.keys(obj).length; 
}

//function to show chosen spec
function showSpec(colName){

	var selectedSpec = $("#bike_collection-kit-selector").val();

	// Because MY24, need to update colours shown and selected before anything else

	//check current showing cols do exist
	$('.bike_collection_options-color_grid').each(function(){
				let me = $(this);
				me.removeClass('tempHiddenBuildColor');
				let thisCol = me.attr('data-colorname');
				
				//hide wrong MY cols
				if( typeof specJSON.Kits[''+selectedSpec+'']['Images'][''+thisCol+''] == "undefined" ){
					
					$(me).addClass('tempHiddenBuildColor');
				}

	})

	var selectedColor = $(".selected-color").attr('data-colorname');

	$('.bike_collection_options-color_grid').each(function(){

	 	let me = $(this);

	if(me.hasClass('tempHiddenBuildColor')){ //remove class from wrong MY cols

	 		me.removeClass('selected-color');

	}else if(typeof colName !== 'undefined'){ //user has changed color
		
		if($(me).attr('data-colorname') == colName){ // if this el has specified col
			$(me).addClass('selected-color');
			$('#bike_collection-color-name').html($(me).attr('data-colorname'));
			return false; // escape loop once first available color is set
		}else{ // isn't the correct color
			me.removeClass('selected-color');
		}

		var selectedColor = $(me).attr('data-colorname');
			
 	}else{ // no col specified, el isn't hidden
 		$('.selected-color').removeClass('selected-color');
 		$(me).addClass('selected-color');
		$('#bike_collection-color-name').html($(me).attr('data-colorname'));

			return false;
 	}
 })

	
var selectedColor = $(".selected-color").attr('data-colorname');



	
	
	//get spec
	var selectedSpec = $("#bike_collection-kit-selector").val();
	

	//use color to show pic
	var newPic = specJSON.Kits[''+selectedSpec+'']['Images'][''+selectedColor+''];
	
  	$('#bike_collection-selected-spec-img').attr('src', newPic);


	//use spec to scroll spec table to correct spec & highlight header border bottom


	//get total number of kits
	var totalNoOfKits = Object.keys(specJSON.Kits).length;
	//make array of Keys
	var aKitKeys = Object.keys(specJSON.Kits);
	var indexOfSpec;
	//loop through array of keys to find index of selected spec
	for (var i = 0; i <= totalNoOfKits -1; i++) {
		
		if( aKitKeys[i] == selectedSpec){
			var indexOfSpec = i;
		}
	}
	
	//get width of a colum of specs
	var widthOfSpecColumn = $('.bike_collection-kits-list').innerWidth();

	//scroll container thingy to index * width
	$('#bike_collection-kit-slider').animate({
            scrollLeft: widthOfSpecColumn * indexOfSpec + 'px'
        });

	//remove then add silly class underline highlighty border thing
	$('.selected-spec-table').removeClass('selected-spec-table');
	$('.bike_collection-comp-header').each(function(){
		if( $(this).attr('data-KitMaterial') == selectedSpec){
			$(this).addClass('selected-spec-table');
		}
	})

	//update price
	var newPrice = specJSON.Kits[''+selectedSpec+'']['Price'];
	$('#bike_collection-options-price').html(newPrice);

	//show Factroy Sale Price

	if( typeof specJSON.Kits[''+selectedSpec+'']['Sale Price'] == 'string'){
		$('.bike_collection-sale-rrp').removeClass('hide')
		var salePrice = specJSON.Kits[''+selectedSpec+'']['Sale Price']
	}else{
		$('.bike_collection-sale-rrp').addClass('hide')
		var salePrice = ""
	}
	$('#bike_collection-options-sale-price').html('Factory Sale Price: ' + salePrice);
}

$(".bike_collection_options-color_grid").click(function(){
	//check if is currently selected color
	if( $(this).hasClass('selected-color') ){
		//is already showing, do nowt
	}else{
		//remove class form previously selected color
		$('.selected-color').removeClass('selected-color');

		$(this).addClass('selected-color');
		//update
		var colName = $(this).attr('data-colorname')
		$('#bike_collection-color-name').html(colName);
		showSpec(colName);


	
		
	}
})

$('#bike_collection-kit-selector').change(function(){
	showSpec();
})

$('.bike_collection-comp-header').click(function(){
	if( $(this).html() == "l" ){
		//do nowt
	}else{
		var targetSpec = $(this).attr('data-KitMaterial');
		var specForSelect = $(this).html();
		
		
		$('#bike_collection-kit-selector').val(targetSpec);
		showSpec();
	}
})

//sticky menu

var startingPosition = $('#bike_collection_nav-container').offset().top;

var navHeight = $('#bike_collection_nav-container').height();

$("#bike_collection-stickyNavBuff").css({"height": navHeight + "px"});


$( window ).scroll(function() {
    
    var scrollTop     = $(window).scrollTop(),
      	elementOffset = $('#bike_collection_nav-container').scrollTop(),
      	distance      = (elementOffset - scrollTop),
      	headerHeight = $("#site__header").height();
    	
    
    if(scrollTop >= (startingPosition - headerHeight)){
      $("#bike_collection_nav-container").addClass("bike_collection-sticky-menu").removeClass('bike_collection-floaty-menu');
      $("#bike_collection-stickyNavBuff").show(0);
      $(".bike_collection-sticky-menu").css({"top": ""+headerHeight -2 +"px" })
      
    }else if(scrollTop < (startingPosition - headerHeight)){
    	$(".bike_collection-sticky-menu").css({"top": "-2.4em" })
      $("#bike_collection_nav-container").removeClass("bike_collection-sticky-menu").addClass('bike_collection-floaty-menu');
      $("#bike_collection-stickyNavBuff").hide(0);
      
    }

    

  });

// on page load, check scroll position & stick menu if needed

var bottomOfHero = $('#bicycle_hero').height(),
headerHeight = $("#site__header").height();

  if ($(window).scrollTop() > bottomOfHero){
    $("#bike_collection_nav-container").addClass("bike_collection-sticky-menu").removeClass('bike_collection-floaty-menu');
      $("#bike_collection-stickyNavBuff").show(0);
      $(".bike_collection-sticky-menu").css({"top": ""+headerHeight -2 +"px" })
  }

$("#bike_size-cm").click(function(){
	if( $(this).hasClass('size-switch-selected') ){

		}else{
			$('.size-switch-selected').removeClass('size-switch-selected');
			$(this).addClass('size-switch-selected');
			$(".bike_collection-size-guide-marker").each(function(){
				$(this).html( $(this).attr('data-cm') )

			})
		}

	
})

$("#bike_size-inch").click(function(){
	if( $(this).hasClass('size-switch-selected') ){

		}else{
			$('.size-switch-selected').removeClass('size-switch-selected');
			$(this).addClass('size-switch-selected');
			$(".bike_collection-size-guide-marker").each(function(){
				$(this).html( $(this).attr('data-inch') )

			})
		}

	
})

$(".bike_collection-resource-q").click(function(){
	$(this).siblings('.bike_collection-resource-a').slideDown();
})

//nav on bike pages
var navHeight = $('.site-header:first').height() + $('.bike_collection_nav-container:first').height();

$("#bike_collection_nav-overview").click(function(){
	$('html,body').animate({
      scrollTop: $('#bike_collection_overview').offset().top - (navHeight + 30)
	},500);
})

$("#bike_collection_nav-details").click(function(){
	$('html,body').animate({
      scrollTop: $('#bike_collection-details').offset().top - (navHeight + 30)
	},500);
})

$("#bike_collection_nav-build").click(function(){
	$('html,body').animate({
      scrollTop: $('#bike_collection_build-options').offset().top - (navHeight + 30)
	},500);
})

$("#bike_collection_nav-geo").click(function(){
	$('html,body').animate({
      scrollTop: $('#bike_collection-geo').offset().top - (navHeight + 30)
	},500);
})

$("#bike_collection_nav-faq").click(function(){
	$('html,body').animate({
      scrollTop: $('#bike_collection-more-resources').offset().top - (navHeight + 30)
	},500);
})

 //if there's 2 geo charts hide the second and create buttons
 var noOfGeotables = jQuery(".geometry_table").length; 

 if(noOfGeotables > 1){
 	jQuery(".geometry_table:eq(1)").hide(0); // hide the second

 	$('.geometry_table').each(function(index, value){
 		var btn_text = $(this).attr('data-title');

 		if(index == 0){
 	 		$('#bike_collection-flipchip').append('<button class = "btn_flipchip geo-selected">'+btn_text+'</button>')	
 		}else{
 			$('#bike_collection-flipchip').append('<button class = "btn_flipchip">'+btn_text+'</button>')
 		}

 		
 	})
 } 


$('.btn_flipchip').click(function(){
	if( $(this).hasClass('geo-selected') ){
		// already selected table - do nowt	
	}else{
		$('.geo-selected').removeClass('geo-selected');
		$(this).addClass('geo-selected');

		$('.geometry_table').each(function(){
			$(this).toggle();
		})
	}

})

$("#bike_collection-show-more-spec").click(function(){

	$("#bike_collection-spec-container").animate({height: $("#bike_collection-spec-container").get(0).scrollHeight}, 600 );
	$("#bike_collection-show-more-spec").fadeOut(400, function(){
		$("#bike_collection-show-more-spec").remove(0);
	})
	
})

$("#btn-skip-to-stock").click(function(){
	$('html,body').animate({
      scrollTop: $('#bb_dealer_list-header').offset().top - (navHeight + 30)
	},900);
})

//if vid exists - set container to same height as img gallery, hide and toggle on btn pokes

function resizeVideoContainer(){

	var galleryHeight = $(".bike_collection-action-shot-container").height();
	$('.bike_collection-vid-container').height(galleryHeight + 'px')
}



$( window ).resize(function() {
	if( $('.bike_collection-vid-container').length ){
		resizeVideoContainer();
	}
})

$('.btn_bike_collection_media-toggle').click(function(){
	resizeVideoContainer();

	//toggle gallery
	$('.bike_collection-action-shot-container').toggle();
	$('.bike_collection-vid-container').toggle();

	//toggle btn class
	$('.btn_bike_collection_media-toggle').each(function(){
		$(this).toggleClass('media-selected');
	})
})

if( $('.bike_collection-vid-container').length ){
	resizeVideoContainer();
}

